import * as React from 'react';

function ParachuteLinens(props) {
  return (
    <svg width='1em' height='1em' viewBox='0 0 20 12' fill='none' {...props}>
      <path
        d='M1.504 8.662h.201v2.168c0 .139.112.251.25.251h2.012a.25.25 0 00.25-.25V8.661h1.936v1.236c0 .138.112.25.25.25h9.38v.682c0 .139.112.251.25.251h2.011a.25.25 0 00.25-.25V8.661h.202c.83 0 1.504-.675 1.504-1.504 0-.83-.675-1.504-1.504-1.504h-.912v-.157c0-.588-.479-1.067-1.067-1.067H7.22c-.589 0-1.067.479-1.067 1.067v.157h-.927V2.83a.937.937 0 00-.936-.936H3.008v-.39C3.008.674 2.333 0 1.504 0 .674 0 0 .675 0 1.504v5.654c0 .83.675 1.504 1.504 1.504zm16.08-2.507h.912a1.004 1.004 0 010 2.006h-.912V6.155zm-.251 3.993a.25.25 0 00.25-.25V8.662h.21v1.918h-1.51v-.432h1.05zM6.654 5.497c0-.312.254-.566.565-.566h9.298c.312 0 .565.254.565.566v4.15H6.654v-4.15zM3.716 10.58h-1.51V8.662h1.51v1.918zm-.708-8.184H4.29c.24 0 .435.195.435.434v2.824H3.008V2.396zM.5 1.504a1.004 1.004 0 012.006 0v4.4c0 .14.112.251.25.251h3.396v2.006H1.504C.951 8.16.502 7.71.502 7.158V1.504z'
        fill='#000'
      />
    </svg>
  );
}

const MemoParachuteLinens = React.memo(ParachuteLinens);
export default MemoParachuteLinens;
